import { Component, Vue } from "vue-property-decorator";
import template from "./logout.template.vue";
import { Getter } from "vuex-class";
import { IWhoAmI } from "@/interfaces";

@Component({
  mixins: [template]
})
export default class LogoutComponent extends Vue {
  @Getter("user", { namespace: "AppModule" })
  public userLogged!: IWhoAmI | null;
  mounted() {
    setTimeout(() => {
      localStorage.clear();
      this.$router.push("/login");
    }, 2500);
  }

  get message() {
    return this.userLogged
      ? `Good bye ${this.userLogged.FName} ${this.userLogged.LName}`
      : "";
  }
}
